import { render, staticRenderFns } from "./NewCustomerScreen.vue?vue&type=template&id=c2c0af9e&scoped=true"
import script from "./NewCustomerScreen.vue?vue&type=script&lang=js"
export * from "./NewCustomerScreen.vue?vue&type=script&lang=js"
import style0 from "./NewCustomerScreen.vue?vue&type=style&index=0&id=c2c0af9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0af9e",
  null
  
)

export default component.exports